import styled from 'styled-components';

import { Button } from 'components/Button';

export const FormRow = styled.div<{
  hasError: boolean;
}>`
  display: flex;
  flex-direction: column;
  .MuiFormHelperText-root {
    margin-top: 0px;
    margin-left: 12px;
    color: ${({ theme }) => theme.palette.error.main};
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.4px;
  }
  .MuiFormControl-fullWidth {
    margin-bottom: 3px;
  }
  margin-bottom: ${(props) => (props.hasError ? 16 : 0)}px;
`;

export const RowLabel = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 0px;
  margin-bottom: 5px;
`;

export const ConfirmVerificationCodeContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DigitsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 10px;
`;

export const FormError = styled.p`
  color: ${({ theme }) => theme.palette.error.main};
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 143%;
  letter-spacing: 0.17px;
  margin-left: 12px;
  margin-top: 8px;
  margin-bottom: 8px;
`;

export const FormInfo = styled(FormError)`
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const FormStatusAnchor = styled.a`
  color: ${({ theme }) => theme.palette.primary.main};
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 143%; /* 20.02px */
  letter-spacing: 0.17px;
  text-decoration: underline;
  cursor: pointer;
`;

export const SubmitButton = styled(Button).attrs({
  type: 'submit',
  size: 'large',
  color: 'primary',
  variant: 'contained',
})`
  height: 42px;
  padding: 7px 21px 7px 21px;
  font-size: 15px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0.46px;
  text-transform: capitalize;
  box-shadow: none;
  margin-top: 8px;
  align-self: flex-end;
`;

export const RecoveryCodesContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RecoveryCodesDescription = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  font-weight: 400;
  line-height: 143%;
  letter-spacing: 0.17px;
  margin-top: 0px;
  margin-bottom: 12px;
`;

export const RecoveryCodesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 16px;
`;

export const RecoveryCode = styled.span`
  font-family: 'Roboto Mono', monospace;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text.primary};
  background-color: ${({ theme }) => theme.palette.action.hover};
  padding: 4px 8px;
  border-radius: 4px;
  letter-spacing: 0.5px;
`;

export const RecoveryCodesActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
`;
